import React from "react";
import { View, Text } from "react-native";
import { useTheme } from "../providers/ThemeProvider";

export const PageBullets = ({
  total,
  currentIndex,
}: {
  total: number;
  currentIndex: number;
}) => {
  const theme = useTheme();
  return (
    <View style={{ flexDirection: "row", justifyContent: "center" }}>
      {Array.from({ length: total }).map((p, i) => (
        <Text
          key={i}
          style={{
            color: theme.backgroundText,
            fontSize: theme.fontSize.h4,
            opacity: currentIndex === i ? 1 : 0.5,
          }}
        >
          &bull;
        </Text>
      ))}
    </View>
  );
};
